import { api } from "@/api";
import { League } from "@/types/ApiResponses/League";

export async function addFavoriteLeague(league: League) {
  const res = await api.client.post("/leagues-new/favorite", {
    leagueId: league.id,
  });
  return res.data;
}
